export enum UmpireProductTypeEnum {
  Umpire = 'umpire',
  OTT = 'ott',
}
